module.exports = __webpack_public_path__ + "static/media/iconsmind.8e0d92f8.ttf";